/* eslint-disable  */

import { lazy } from "react";

const Profile = lazy(() => import("../../views/pages/profile"));
const Error = lazy(() => import("../../views/pages/misc/Error"));
const Error500 = lazy(() => import("../../views/pages/misc/Error500"));

const ComingSoon = lazy(() => import("../../views/pages/misc/ComingSoon"));
const Maintenance = lazy(() => import("../../views/pages/misc/Maintenance"));
const AccountSettings = lazy(() =>
  import("../../views/pages/account-settings")
);
const NotAuthorized = lazy(() =>
  import("../../views/pages/misc/NotAuthorized")
);

const Container = lazy(() => import("../../views/pages/container"));

const PagesRoutes = [
  {
    element: <Container />,
    path: "/pages/container",
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/pages/profile",
    element: <Profile />,
  },

  {
    path: "/pages/account-settings",
    element: <AccountSettings />,
  },

  {
    path: "/misc/coming-soon",
    element: <ComingSoon />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
  {
    path: "/misc/not-authorized",
    element: <NotAuthorized />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
  {
    path: "/misc/maintenance",
    element: <Maintenance />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
  {
    path: "/misc/error",
    element: <Error />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
  {
    path: "/misc/error500",
    element: <Error500 />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
];

export default PagesRoutes;
